import React from 'react';

interface Props {
  title: string;
  status?: string | null;
}

export const RtuStaticModuleCardTitle = ({ title, status }: Props) => {
  const statusLabel = status?.trim();

  return (
    <div className="rtu-static-module-card__title">
      <span className="rtu-static-module-card__title-label">{title}</span>
      {statusLabel ? (
        <span className="rtu-static-module-card__title-status">{statusLabel}</span>
      ) : null}
    </div>
  );
};

export default RtuStaticModuleCardTitle;
